import logoWht from "./ultra_logo_white.svg";
import speedMeter from "./speedometer.svg";
import rightTop from "./upside_right.svg";
import leftBottom from "./downside-left.svg";
import faceBook from "./appIcon/facebook.svg";
import exportIcon from "./downloadIcon.svg";
import bulb from "./bulb.svg";
import comingSoon from "./comming-soon.svg";
import comingSoonAnalytics from "./comming-soon-analytics.svg";
import logo from "./logo.svg";
import ultraLogo from "./ultraLogo.webp";
import audienceLogo from "./appIcon/audience_icon1.svg";
import messengerLogo from "./appIcon/messanger.svg";
import threads from "./appIcon/threads.svg";
import instagramLogo from "./appIcon/instagram_icon1.svg";
import facebookLogo from "./appIcon/facebook_icon1.svg";
import instagram from "./appIcon/instagram.svg";
import InstagramLogo from "./InstagramLogo.wine.svg";
import Meta from "./meta-icon.svg";
import eventDataFlow from "./event-data-flow.svg";
import optimisation from "./optimisation.svg";
import campaignConfig from "./campaign-config.svg";
import competitionInsight from "./competition-insight.svg";
import audienceRecomendation from "./audience-recomendation.svg";
import mDMP from "./mDMP.svg";
import partner1 from "./partner/partner1.svg";
import partner2 from "./partner/partner2.svg";
import partner3 from "./partner/partner3.svg";
import partner4 from "./partner/partner4.svg";
import partner5 from "./partner/partner5.svg";
import GoogleAd from "./google-ads.svg";
import idea from "./idea.svg";
import Default_Creative from "./Default_Creative.png";
import takeOff1 from "./icons/take-off-1.svg";
import takeOff2 from "./icons/take-off-2.svg";
import takeOff3 from "./icons/take-off-3.svg";
import takeOff4 from "./icons/take-off-4.svg";
import takeOff5 from "./icons/take-off-5.svg";
import wallet from "./wallet.svg";
import IrisLogo from "./IrisLogo.svg";
import IrisLogoEmail from "./UltraIris-Email.png";
import AiDataGuy from "./ai-data-not-found.svg";
import LeftDoor from "./Sidebar_Left_Outline.svg";
import RightDoor from "./Sidebar_Right_Outline.svg";
import filter from "./filter.png";
import UploadImg from "./uploading-illustration.svg";
import connectShop from "./connectShop.png";
import addChannel from "./add-channel.png";
import csv from "./csv.svg";
import xml from "./xml.svg";
import shopify from "./shopify.svg";
import comingSoonProductStats from "./comingSoonProductStats.png";
import feed_error from "./feed_error.png";

const images = {
  filter,
  shopify,
  csv,
  UploadImg,
  LeftDoor,
  RightDoor,
  connectShop,
  addChannel,
  AiDataGuy,
  wallet,
  takeOff1,
  takeOff2,
  takeOff3,
  takeOff4,
  takeOff5,
  idea,
  GoogleAd,
  partner1,
  partner2,
  partner3,
  partner4,
  partner5,
  mDMP,
  eventDataFlow,
  optimisation,
  campaignConfig,
  competitionInsight,
  audienceRecomendation,
  Meta,
  instagram,
  InstagramLogo,
  ultraLogo,
  messengerLogo,
  instagramLogo,
  facebookLogo,
  audienceLogo,
  logoWht,
  speedMeter,
  rightTop,
  leftBottom,
  faceBook,
  exportIcon,
  bulb,
  comingSoon,
  comingSoonAnalytics,
  logo,
  Default_Creative,
  IrisLogo,
  IrisLogoEmail,
  comingSoonProductStats,
  feed_error,
  xml,
  threads,
};

export default images;
